import React from 'react';
import { Card, Box, Button } from '@mui/joy';

import Menu from '@mui/joy/Menu';
import MenuButton from '@mui/joy/MenuButton';
import MenuItem from '@mui/joy/MenuItem';
import Dropdown from '@mui/joy/Dropdown';
import Divider from '@mui/joy/Divider';

import SaveIcon from '@mui/icons-material/Save';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import SendSharpIcon from '@mui/icons-material/SendSharp';
import AddIcon from '@mui/icons-material/Add';

const PostSaveSchedule = ({ handleSavePost, setIsScheduleModalOpen, setIsPostNowModalOpen, postId, newDraft }) => {
    return (
        <Card sx={{ padding: 2, borderRadius: 0, borderLeft: 0, borderRight: 0, borderBottom: 0 }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                
                <Button variant="solid" color="success" sx={{ marginRight: '10px' }} onClick={handleSavePost}>
                    <SaveIcon sx={{ marginRight: '5px' }} />
                    Save Post
                </Button>

             
                <Dropdown >
                    <MenuButton variant="solid" color="primary" disabled={!postId}>
                        <WatchLaterOutlinedIcon sx={{ marginRight: '5px' }} />
                        Schedule Post</MenuButton>
                    <Menu sx={{ zIndex: 99999 }}>
                        <MenuItem onClick={() => setIsScheduleModalOpen(true)}>
                            <WatchLaterOutlinedIcon sx={{ marginRight: '5px' }} />
                            Schedule
                        </MenuItem>
                        <Divider sx={{ mb: 1, mt: 1 }} />
                        <MenuItem onClick={() => setIsPostNowModalOpen(true)}>
                            <SendSharpIcon sx={{ marginRight: '5px' }} />
                            Post Now
                        </MenuItem>
                    </Menu>
                </Dropdown>


                <Divider orientation='vertical' sx={{ ml: 3, mr: 3 }} />

                <Button variant="outlined" color="primary" sx={{ marginLeft: '10px' }} onClick={newDraft}>
                    <AddIcon sx={{ marginRight: '5px' }} />
                    New Draft
                </Button>
            </Box>
        </Card>
    );
};

export default PostSaveSchedule;
